import { Box, Typography } from '@mui/material';

import SectionTitle from '../../components/SectionTitle';

const contents = [
  'Hầu hết các phản ứng phổ biến nhất đối với truyền máu tươi hoặc các sản phẩm máu truyền',
  'Là:',
  'Sốt cao',
  'Phát ban, ngứa',
  'Mệt mỏi',
  'Triệu chứng hiếm :',
  'Quá nhiều máu dẫn đến khó thở',
  'Hồng cầu phân huỷ một cách bất thường',
  'Sự phát triển của các kháng thể có thể gây trở ngại cho việc truyền máu trong tương lai. Nếu những biến chứng này xảy ra ở phụ nữ thì có thể gây hại ch thai nhi',
  'Chấn thương phổi gây khó thở.',
  'Sự lây lan của vi-rút hoặc các mầm bệnh truyền nhiễm khác từ máu của người hiến tặng.',
  'Tuy rất hiếm nhưng những phản ứng trên có thể gây ra thiệt hại nghiêm trọng hoặc có thể dẫn đến tử vong',
  'Có những vấn đề cụ thể đối với nhiều ca truyền máu dài hạn có thể liên quan đến tình trạng sức khỏe du lịch. (Bác sĩ của bạn sẽ thảo luận những điều này với bạn)',
];

const CContents = () => {
  return (
    <>
      <SectionTitle title="C. Nguy cơ truyền máu và/hoặc các sản phẩm máu" />
      <Box sx={{ width: '98%', margin: '48px auto 24px auto' }}>
        {contents.map((v, i) => {
          if (i === 0) {
            return (
              <Typography
                sx={{ fontWeight: '500', fontSize: '15px', lineHeight: '24px' }}
              >
                {v}
              </Typography>
            );
          }
          if (i === 1 || i === 5) {
            return (
              <Typography
                sx={{ fontWeight: '400', fontSize: '15px', lineHeight: '24px' }}
              >
                <p />
                {v}
              </Typography>
            );
          }
          return (
            <Typography
              sx={{
                fontWeight: '400',
                fontSize: '15px',
                lineHeight: '24px',
                whiteSpace: 'pre-wrap',
              }}
            >
              • {v}
            </Typography>
          );
        })}
      </Box>
    </>
  );
};

export default CContents;
